import React from 'react'

export default function CheckBoxGroup({ values = [], selected = [], onChange, groupId = 'default' }) {
  const handleToggle = (value) => {
    const newSelected = selected.includes(value)
      ? selected.filter(item => item !== value)
      : [...selected, value]

    if (onChange) {
      onChange(newSelected)
    }
  }

  return (
    <div class='component_CheckBoxGroup'>
      {values.map((item, index) => {
        const uniqueId = `checkbox-${groupId}-${index}`
        return (
          <div key={index} class='form-check mb-2'>
            <input
              class='form-check-input'
              type='checkbox'
              id={uniqueId}
              checked={selected.includes(item.value)}
              onChange={() => handleToggle(item.value)}
            />
            <label class='form-check-label' htmlFor={uniqueId}>
              {item.key}
            </label>
          </div>
        )
      })}
    </div>
  )
}
